// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-content-wrap[data-v-50e49170] {\n  max-width: 1100px;\n}\n.animation-preview[data-v-50e49170] {\n  width: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
